let animationFrameIds = [];

const RESTART_EVENT = 'countdown:restart'; 

function initializeDailyCountdown() {
    animationFrameIds.forEach(cancelAnimationFrame);
    animationFrameIds = [];

    const wrappers = document.querySelectorAll(".countdown-wrapper-daily");

    if (wrappers.length === 0) {
        return;
    }

    const getHostSuffix = () => {
        const host = window.location.host;
        if (host.includes(".au")) return "au";
        if (host.includes(".nz")) return "nz";
        return "default";
    };

    const updateSingleCountdown = (wrapper) => {
        const countdown = wrapper.querySelector(".countdown-daily");
        if (!countdown) return;

        const hourElem = countdown.querySelector(".hour");
        const minElem = countdown.querySelector(".min");
        const secElem = countdown.querySelector(".sec");

        if (!hourElem || !minElem || !secElem) return;

        const target = countdown;
        const now = new Date();
        const timeAttr = target.getAttribute("data-time");
        if (!timeAttr) return;

        const [targetHour, targetMin] = timeAttr.split(":").map(Number);
        const timeZone = target.getAttribute("data-timezone") || "Australia/Brisbane";
        const dateInTz = new Intl.DateTimeFormat("en-CA", {
          timeZone,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }).format(now);
        const hh = String(targetHour).padStart(2, "0");
        const mm = String(targetMin).padStart(2, "0");
        const endTime = Date.parse(`${dateInTz}T${hh}:${mm}:00+10:00`);

        const endCallback = () => {
            const isCleanDrawer = Boolean(wrapper.closest("cart-drawer.cart-drawer--clean"));
            if (isCleanDrawer) {
                wrapper.innerHTML = "";
                return;
            }

            const hostType = getHostSuffix();
            if (hostType === "au") {
                wrapper.innerHTML = "<span>Buy Now Pay Later - Afterpay | Zip</span>";
            } else if (hostType === "nz") {
                wrapper.innerHTML = "<span>Buy Now Pay Later - Afterpay</span>";
            } else {
                wrapper.innerHTML = "<span>Buy Now Pay Later - Afterpay</span>";
            }
        };

        const tick = () => {
            const nowTime = new Date().getTime();
            const distance = endTime - nowTime;

            if (distance <= 0) {
                endCallback();
                return;
            }

            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            const compact = Boolean(wrapper.closest("cart-drawer.cart-drawer--clean"));

            if (compact) {
                hourElem.querySelector(".num").textContent = hours;
                hourElem.querySelector(".word").textContent = "h";
                minElem.querySelector(".num").textContent = minutes;
                minElem.querySelector(".word").textContent = "m";
                secElem.querySelector(".num").textContent = seconds;
                secElem.querySelector(".word").textContent = "s";
            } else {
                const addZero = (x) => (x < 10 && x >= 0 ? "0" + x : x);
                hourElem.querySelector(".num").textContent = addZero(hours);
                hourElem.querySelector(".word").textContent = "hours";
                minElem.querySelector(".num").textContent = addZero(minutes);
                minElem.querySelector(".word").textContent = "minutes";
                secElem.querySelector(".num").textContent = addZero(seconds);
                secElem.querySelector(".word").textContent = "seconds";
            }

            const id = requestAnimationFrame(tick);
            animationFrameIds.push(id);
        };
        
        const initialId = requestAnimationFrame(tick);
        animationFrameIds.push(initialId);
    };

    const isDispatchWeekend = () => {
        try {
            const day = new Intl.DateTimeFormat("en-US", {
                weekday: "short",
                timeZone: "Australia/Brisbane",
            }).format(new Date());
            return day === "Sat" || day === "Sun";
        } catch (e) {
            const weekday = new Date().getDay();
            return weekday === 0 || weekday === 6;
        }
    };

    wrappers.forEach((wrapper) => {
        const isCleanDrawer = Boolean(wrapper.closest("cart-drawer.cart-drawer--clean"));
        if (isCleanDrawer && isDispatchWeekend()) {
            const root = wrapper.closest(".countdown-wrapper") || wrapper;
            root.hidden = true;
            return;
        }
        updateSingleCountdown(wrapper);
    });
}

document.addEventListener('DOMContentLoaded', initializeDailyCountdown);

document.addEventListener(RESTART_EVENT, initializeDailyCountdown);